import { useEffect } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { IFRAME_ID } from "./constants";

/**
 * Custom hook for handling scroll to block functionality in Builder UI frames
 */
export const useScrollToBlock = () => {
  const blockPathToBeScrolledTo = useBuilderStore(
    state => state.blockPathToBeScrolledTo,
  );

  useEffect(() => {
    if (!blockPathToBeScrolledTo) return;

    // IFrame calculations timeout.
    const timeoutForRendering = setTimeout(() => {
      const iframe = document.getElementById(IFRAME_ID) as HTMLIFrameElement;
      if (!iframe || !iframe.contentDocument) return;

      const element = iframe.contentDocument.querySelector(
        `[data-block-path="${blockPathToBeScrolledTo}"]`,
      );
      if (!element) return;

      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 1);

    return () => {
      clearTimeout(timeoutForRendering);
    };
  }, [blockPathToBeScrolledTo]);
};
